import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';

@Injectable()
export class MaintenanceApiService extends BaseApiService {
  getMaintenances() {
    return this.http.get(this.baseUrl + '/maintenances');
  }
}
